export default __webpack_public_path__ + "static/media/detail-1.3d3c1493.svg";